import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Config, getConfigs } from '../../api/configsApi';
import { AppThunk } from '../../app/store';
import { decrease, increase } from '../loading/loadingSlice';

const initialState = null as Config[] | null;

const configsSlice = createSlice({
  name: 'configs',
  initialState,
  reducers: {
    setConfigs: (state, action: PayloadAction<Config[]>) => {
      return [...state || [], ...action.payload];
    }
  }
});

export const fetchConfigs = (): AppThunk => async dispatch => {
  dispatch(increase());
  try {
    const configs = await getConfigs();
    dispatch(setConfigs(configs || []));
  } catch (error: any) {
    console.log(error.toString());
  } finally {
    dispatch(decrease());
  }
};

export const { setConfigs } = configsSlice.actions;

export default configsSlice.reducer;
